import { BrowserRouter, Route, Routes } from "react-router-dom"
import Win from "./nav/Win"
import Contact from "./nav/Contact"
import Error from "./nav/Error"
import FAQ from "./nav/FAQ"
import Imprint from "./nav/Imprint"
import Memory from "./nav/Memory"
import Privacy from "./nav/Privacy"
import Promoover from "./nav/Promoover"
import Terms from "./nav/Terms"
import Store from "./store/store"
import Lose from "./nav/Lose"
import ConfirmContact from "./nav/ConfirmContact"
import { Header } from "./components/Header"
import { useEffect } from "react"
import { updateIframeHeight } from "./helper"
import Home from "./nav/Home"
import Promosoon from "./nav/Promosoon"

const App = () => {
	// useEffect(() => {
	// 	const isNotInIframe = window.top === window.self
	// 	const isOnCorrectDomain = window.location.hostname === "prod.fe.nimm2-der-sommer-lacht-fe.campaign-loyalty.com"

	// 	if (isNotInIframe && isOnCorrectDomain) {
	// 		window.location.href = "https://www.nimm2.de/de/der-sommer-lacht"
	// 	}
	// }, [])

	// Mon Aug 18 2025 0:0:0 UTC+0200 (Mitteleuropäische Sommerzeit)
	const isPromoOver = parseInt(Math.floor(Date.now() / 1000).toString()) > 1755468000

	useEffect(() => {
		updateIframeHeight()
		window.addEventListener("load", () => updateIframeHeight("load"))
		window.addEventListener("resize", () => updateIframeHeight("resize"))
		window.addEventListener("focus", () => updateIframeHeight("focus"))
	}, [])

	useEffect(() => {
		const params = new URLSearchParams(window.location.search)
		const noCache = params.get("no_cache")

		if (noCache !== "1") {
			const script = document.createElement("script")
			script.innerHTML = `
        window.onload = function () {
          const message = 'domready';
          window.parent.postMessage({ content: message }, '*');
          window.addEventListener('message', function (event) {
            if (event.data.cookieStatus === "accepted") {
              (function (window, document, dataLayerName, id) {
                window[dataLayerName] = window[dataLayerName] || [], window[dataLayerName].push({ start: (new Date).getTime(), event: "stg.start" });
                var scripts = document.getElementsByTagName('script')[0], tags = document.createElement('script');
                function stgCreateCookie(a, b, c) {
                  var d = "";
                  if (c) {
                    var e = new Date;
                    e.setTime(e.getTime() + 24 * c * 60 * 60 * 1e3),
                    d = "; expires=" + e.toUTCString();
                  }
                  document.cookie = a + "=" + b + d + "; path=/"
                }
                var isStgDebug = (window.location.href.match("stg_debug") || document.cookie.match("stg_debug")) && !window.location.href.match("stg_disable_debug");
                stgCreateCookie("stg_debug", isStgDebug ? 1 : "", isStgDebug ? 14 : -1);
                var qP = [];
                dataLayerName !== "dataLayer" && qP.push("data_layer_name=" + dataLayerName),
                isStgDebug && qP.push("stg_debug");
                var qPString = qP.length > 0 ? ("?" + qP.join("&")) : "";
                tags.nonce = 'nonce-' + id;
                tags.async = !0;
                tags.src = "https://logfiles.storck.com/containers/" + id + ".js" + qPString;
                scripts.parentNode.insertBefore(tags, scripts);
                !function (a, n, i) {
                  a[n] = a[n] || {};
                  for (var c = 0; c < i.length; c++)!function (i) {
                    a[n][i] = a[n][i] || {},
                    a[n][i].api = a[n][i].api || function () {
                      var a = [].slice.call(arguments, 0);
                      "string" == typeof a[0] && window[dataLayerName].push({ event: n + "." + i + ":" + a[0], parameters: [].slice.call(arguments, 1) });
                    }
                  }(i[c])
                }(window, "ppms", ["tm", "cm"]);
              })(window, document, 'dataLayer', '95e18a75-54ad-4825-9f5c-ff3fbddf7511');
            }
          });
        }
      `
			document.body.appendChild(script)
		}
	}, [])

	return (
		<BrowserRouter basename={`${process.env.PUBLIC_URL}`}>
			<div>
				<Store>
					<Header />
					<main>
						<Routes>
							{isPromoOver ? (
								<>
									<Route path="/" element={<Promoover />} />
									<Route path="/memory" element={<Promoover />} />
								</>
							) : (
								<>
									<Route path="/" element={<Home />} />
									<Route path="/memory" element={<Memory />} />
									<Route path="/bestaetigung" element={<Win />} />
									<Route path="/kontakt/bestaetigung" element={<ConfirmContact />} />
									<Route path="/keinmatch" element={<Lose />} />
									<Route path="/promosoon" element={<Promosoon />} />
									<Route path="/promoover" element={<Promoover />} />
								</>
							)}
							<Route path="/faq" element={<FAQ />} />
							<Route path="/datenschutz" element={<Privacy />} />
							<Route path="/teilnahmebedingungen" element={<Terms />} />
							<Route path="/impressum" element={<Imprint />} />
							<Route path="/kontakt" element={<Contact />} />
							<Route path="/:err" element={<Error />} />
						</Routes>
					</main>
				</Store>

				{/* <div className="bg-white pb-20">
					<a href="https://www.nimm2.de/de/ideen-inspirationen" target="_parent" rel="noopener noreferrer" className="block max-w-6xl mx-auto">
						<img src={process.env.PUBLIC_URL + "/images/inspirationen/nimm2-DE-der-sommer-lacht-ideen-inspirationen-desktop.jpg"} className="hidden lg:block w-full " alt="" />
						<img
							src={process.env.PUBLIC_URL + "/images/inspirationen/nimm2-DE-der-sommer-lacht-ideen-inspirationen-tablet.jpg"}
							className="hidden sm:block lg:hidden w-full "
							alt=""
						/>
						<img src={process.env.PUBLIC_URL + "/images/inspirationen/nimm2-DE-der-sommer-lacht-ideen-inspirationen-mobile.jpg"} className="sm:hidden w-full " alt="" />
					</a>
				</div> */}
			</div>
		</BrowserRouter>
	)
}

export default App
